// deps
import React, { useMemo, useContext } from "react";

// internal-deps
import { WalletGroup, PaymentProgressLoader, IWalletPaymentGroup } from "@swiggy-private/payment-ui";
import { UserContext } from "@swiggy-private/checkout-core";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// helpers
import { canRenderWallet } from "@payment-client/helpers/WalletHelper";

// hooks
import { useWalletHandler } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UseWalletHandler";

interface WalletGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: IWalletPaymentGroup["paymentData"];
}

export function WalletGroupHandler(props: WalletGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const { user: userContextValue } = useContext(UserContext);
    const paymentMethods = props.paymentGroup.paymentMethods;
    const paymentMethodsCanRender = useMemo(
        () => paymentMethods.filter((paymentMethod) => canRenderWallet(userContextValue, paymentMethod)),
        [paymentMethods, userContextValue],
    );

    const paymentGroupToRender = useMemo(
        () => ({ ...props.paymentGroup, paymentMethods: paymentMethodsCanRender }),
        [props.paymentGroup, paymentMethodsCanRender],
    );

    const { paymentActions, user, showProgressLoader } = useWalletHandler(props);

    return (
        <>
            <WalletGroup
                paymentActions={paymentActions}
                user={user}
                paymentData={paymentGroupToRender}
                {...otherProps}
            />
            {showProgressLoader && <PaymentProgressLoader />}
        </>
    );
}
